import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Container } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import { transition } from './../../../common/Mixins'
import media from './../../../common/MediaQueries'
import { ButtonContentStyled } from './../../atoms/Button/styles'
import { HeaderStyleProps } from './types'

const HeaderWrapperStyled = styled.div`
  position: relative;
  width: 100%;
  z-index: 4;
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.16);
`

const HeaderInnerStyled = styled(Container)`
  width: 100%;
`

const HeaderTopStyled = styled.div<WithTheme>`
  /* position: relative; */
  background-color: ${({ theme }) => theme.colors.grayLight};
  z-index: 4;
`

const HeaderBarStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 2.5rem;
  padding: 0.6875rem 0;

  @media ${media.phone} {
    justify-content: flex-end;
  }
`

const HeaderBarLinksStyled = styled.div``

const HeaderBarLanguageStyled = styled.div`
  z-index: 4;
  @media ${media.phone} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-right: 5rem;' : 'margin-left: 5rem;')}
  }
`

const HeaderBotStyled = styled.div<WithTheme>`
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 3;
`

const HeaderContainerStyled = styled.div`
  ${transition}
  display: flex;
  align-items: center;
  width: 100%;
  @media ${media.maxTablet} {
    padding: 1.5625rem 0;
    max-height: 5.125rem;
  }

  @media ${media.tablet} {
    justify-content: flex-end;
    max-height: 8.875rem;
    padding: 3rem 0;
  }
`

const HeaderBurgerStyled = styled.div`
  @media ${media.tablet} {
    display: none;
  }
`

const HeaderLogoStyled = styled.div`
  ${transition}

  &:hover {
    opacity: 0.8;
  }
  @media ${media.maxTablet} {
    order: 2;
  }
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: auto;' : 'margin-right: auto')}
  }
`

const HeaderNavWrapperStyled = styled.div`
  z-index: 2;
  @media ${media.maxTablet} {
    order: 1;
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 3.5rem;' : 'margin-right: 3.5rem;')}
  }
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 1.25rem;' : 'margin-right: 1.25rem;')}
  }
  @media ${media.desktop} {
    ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 3.75rem;' : 'margin-right: 3.75rem;')}
  }
`

const HeaderNavStyled = styled.div<WithTheme<HeaderStyleProps>>`
  display: flex;
  //align-items: center;
  flex-direction: column;

  width: 70vw;
  @media ${media.phone} {
    width: 20rem;
  }

  @media ${media.maxTablet} {
    padding: 1.25rem 1.5625rem 1.25rem 1.25rem;
    z-index: 999;
    position: fixed;
    top: 0;
    height: 100vh;
    //overflow: hidden;
    overflow: visible;
    visibility: hidden;
    opacity: 0;
    background-color: ${({ theme }) => theme.colors.white};
    transform: translateX(0rem);
    transition: 500ms cubic-bezier(0.19, 1, 0.22, 1) 200ms;
    box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.16);

    ${({ theme }) =>
      theme.direction === 'rtl'
        ? css`
            right: 100vw;
          `
        : css`
            left: -100vw;
          `}

    ${({ isOpened }) =>
      isOpened &&
      css`
        transform: translateX(100vw);
        visibility: visible;
        opacity: 1;
      `}
  }
  @media ${media.tablet} {
    flex-direction: row;
    width: auto;
  }
`

const HeaderNavContainerStyled = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};

  @media ${media.maxTablet} {
    max-height: calc(100% - 6.25rem);
    overflow: auto;
  }
  @media ${media.tablet} {
    flex-direction: row;
    width: auto;
  }
`

// Mobile Additional Content --------------------
const HeaderNavHeadStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  @media ${media.tablet} {
    display: none;
  }
`
const HeaderNavHeadLogoStyled = styled.div``

const HeaderNavHeadCloseStyled = styled.div`
  color: ${({ theme }) => theme.colors.green};
  svg {
    transform: rotate(180deg);
  }
`
// ------------------------------

const HeaderNavMenuStyled = styled.div`
  @media ${media.maxTablet} {
    width: 100%;
    margin-bottom: 1.5rem;
    padding-left: 0.5rem;
  }
  @media ${media.tablet} {
    ${({ theme }) => (theme.direction === 'rtl' ? ' margin-left: 2.5rem;' : ' margin-right: 2.5rem;')}
  }
`

const HeaderNavButtonsStyled = styled.div`
  display: flex;

  @media ${media.maxTablet} {
    width: 100%;
    flex-direction: column;
    padding-left: 0.5rem;
  }

  @media ${media.tablet} {
    flex-direction: row;
  }
`

const HeaderNavButtonsItemStyled = styled.div`
  max-width: 10rem;
  @media ${media.maxTablet} {
    &:not(:last-of-type) {
      margin-bottom: 0.625rem;
    }
  }
  @media ${media.tablet} {
    &:not(:last-of-type) {
      ${({ theme }) => (theme.direction === 'rtl' ? 'margin-left: 1.5rem;' : 'margin-right: 1.5rem;')}
    }
    ${ButtonContentStyled} {
      min-width: 7.5rem;
    }
  }
  @media ${media.desktop} {
    ${ButtonContentStyled} {
      min-width: 10rem;
    }
  }
`

const HeaderSearchStyled = styled.div`
  ${transition}
  display: flex;
  color: ${({ theme }) => theme.colors.green};
  width: 1rem;
  height: 1rem;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
  svg {
    height: 1em;
  }
  @media ${media.maxTablet} {
    order: 3;
    margin-left: auto;
  }
`

const HeaderSearchBarStyled = styled.div<WithTheme<HeaderStyleProps>>`
  ${transition}
  position: absolute;
  background: ${({ theme }) => theme.colors.white};
  transform: translateY(-50%);
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 0;
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.16);
  z-index: -1;
  ${({ isActive }) =>
    isActive &&
    css`
      transform: translateY(100%);
      padding: 0.5rem 0 1rem;
    `}
`

const HeaderOverlayStyled = styled.div<WithTheme<HeaderStyleProps>>`
  display: none;

  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: ${({ theme }) => theme.colors.white};
  opacity: 0.7;
  z-index: 1;

  ${({ isVisible }) =>
    isVisible &&
    css`
      display: block;
    `}
`

const HeaderStyled = styled.header<WithTheme<HeaderStyleProps>>`
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  box-shadow: 0rem 0.3125rem 0.9375rem 0rem rgba(0, 0, 0, 0.07);
  // height: 241px;
  @media ${media.tablet} {
    // height: 273px;
  }

  ${({ isMenuOpened }) =>
    isMenuOpened &&
    css`
      ${HeaderBotStyled} {
        z-index: 5;
      }
    `}

  ${({ isPageScrolled }) =>
    isPageScrolled &&
    css`
      /* position: fixed; */
      ${HeaderWrapperStyled} {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
      }
      ${HeaderContainerStyled} {
        padding: 0.75rem 0;
      }
      @media ${media.tablet} {
        ${HeaderContainerStyled} {
          padding: 1.5rem 0;
        }
      }
    `}
`

export {
  HeaderStyled,
  HeaderWrapperStyled,
  HeaderInnerStyled,
  HeaderTopStyled,
  HeaderBarStyled,
  HeaderBarLinksStyled,
  HeaderBarLanguageStyled,
  HeaderBotStyled,
  HeaderContainerStyled,
  HeaderBurgerStyled,
  HeaderLogoStyled,
  HeaderNavWrapperStyled,
  HeaderNavStyled,
  HeaderNavContainerStyled,
  HeaderNavHeadStyled,
  HeaderNavHeadLogoStyled,
  HeaderNavHeadCloseStyled,
  HeaderNavMenuStyled,
  HeaderNavButtonsStyled,
  HeaderSearchStyled,
  HeaderNavButtonsItemStyled,
  HeaderSearchBarStyled,
  HeaderOverlayStyled
}
